export default "__VITE_ASSET__CHXncF4$__"